let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8736I")).then(() => parcelRequire('gp0ta'));